// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentCasePrescriptionRelationshipModel {
    static getAttributeTypeMap() {
        return EnrollmentCasePrescriptionRelationshipModel.attributeTypeMap;
    }
}
EnrollmentCasePrescriptionRelationshipModel.discriminator = undefined;
EnrollmentCasePrescriptionRelationshipModel.attributeTypeMap = [
    {
        "name": "prescriptionId",
        "baseName": "prescriptionId",
        "type": "number"
    },
    {
        "name": "prescriberId",
        "baseName": "prescriberId",
        "type": "number"
    },
    {
        "name": "documentId",
        "baseName": "documentId",
        "type": "number"
    }
];
//# sourceMappingURL=enrollmentCasePrescriptionRelationshipModel.js.map